// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10hRV","content":"styles_content__2UMTY","tableWrap":"styles_tableWrap__3UUxQ"};